import React from "react";
import { Col, Row, Tabs } from "antd";
import useStockItemContext from "../../hooks/useStockItemContext";
import { useSelector } from "react-redux";
import StockItemsTab from "./components/StockItemsTab";
import StockMovementsTab from "./components/movements/StockMovementsTab";
import StockItemNewModal from "./components/StockItemNewModal";
import DrawerSupplier from "../../components/drawers/supplier";
import GroupItemForm from "../groupItem/form";
import ItemsGroupForm from "../itemsGroup/form";
import StockIcon from "../../components/admin/sidebar/icons/stock";
import { PageTitle } from "./components/styles";

const { TabPane } = Tabs;

// const PlaceholderTab = () => (
//   <div style={{ textAlign: "center", padding: 48, color: "#888" }}>
//     Em breve
//   </div>
// );

const StockPage = () => {
  const { translation } = useSelector((state) => state.app);
  const t = translation?.stockItem || {};
  const tabs = t.tabs || {};

  const { activeTab, handleTabChange } = useStockItemContext();

  return (
    <div style={{ padding: "14px 0 24px 0" }}>
      {/* Header */}
      <Row type="flex" style={{ marginBottom: "1rem" }}>
        <Col span={24}>
          <PageTitle>
            <StockIcon />
            <span>{translation.sidebar.stock}</span>
          </PageTitle>
        </Col>
      </Row>
      <Tabs
        activeKey={String(activeTab)}
        onChange={(key) => handleTabChange(Number(key))}
        type="card"
      >
        <TabPane tab={tabs.stockItems || "Itens Estoque"} key="0">
          <StockItemsTab />
        </TabPane>
        <TabPane tab={tabs.materialMovements || "Movto Mat."} key="1">
          <StockMovementsTab />
        </TabPane>
      </Tabs>
      <StockItemNewModal />
      <DrawerSupplier />
      <GroupItemForm />
      <ItemsGroupForm />
    </div>
  );
};

export default StockPage;
